module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA2AQMAAAALaq7rAAAABlBMVEX/sRn/9eLYQonzAAAAGklEQVQoz2NgGBCQQA0e/3/cPOrYMAqGIwAA1QYF3QBhZOgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/btn-add-group.png
// module id = 15
// module chunks = 0